export enum language {
    english = "en" ,
    spanish = "es",
    chinese = "zh"
    //chinese = "chi"
}
